// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { cancelSuccessEvaluationRequestToJson, cancelTestRunV2RequestToJson, deleteTestCasesRequestToJson, deleteTestSuiteRequestToJson, generateTestCasesRequestToJson, generateTestCasesResponseFromJson, getSuccessEvaluatorStatRequestToJson, getSuccessEvaluatorStatResponseFromJson, getTestResultRequestToJson, getTestResultResponseFromJson, getTestRunV2RequestToJson, getTestRunV2ResponseFromJson, getTestSuiteRequestToJson, getTestSuiteResponseFromJson, listSuccessEvaluatorResultsRequestToJson, listSuccessEvaluatorResultsResponseFromJson, listSuccessEvaluatorStatsForAssistantRequestToJson, listSuccessEvaluatorStatsForAssistantResponseFromJson, listTestCasesByAssistantRequestToJson, listTestCasesByAssistantResponseFromJson, listTestResultsRequestToJson, listTestResultsResponseFromJson, listTestRunsRequestToJson, listTestRunsResponseFromJson, listTestSuitesRequestToJson, listTestSuitesResponseFromJson, retryStuckTestResultsRequestToJson, retryStuckTestResultsResponseFromJson, runSuccessEvaluationRequestToJson, runSuccessEvaluationResponseFromJson, runTestsV2RequestToJson, runTestsV2ResponseFromJson, startBulkSuccessEvaluationRequestToJson, startBulkSuccessEvaluationResponseFromJson, upsertTestCasesRequestToJson, upsertTestSuiteRequestToJson, upsertTestSuiteResponseFromJson, validateTestCasesRequestToJson, validateTestCasesResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function listTestCasesByAssistant(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.IntegrationTestService/ListTestCasesByAssistant', listTestCasesByAssistantRequestToJson(request));
    return listTestCasesByAssistantResponseFromJson(raw);
}
export function listTestCasesByAssistant$(request, options) {
    return defer(() => listTestCasesByAssistantWithTransport$(getGlobalTransport(), request, options));
}
export function listTestCasesByAssistantWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.IntegrationTestService/ListTestCasesByAssistant', listTestCasesByAssistantRequestToJson(request), options)
        .pipe(map(resp => listTestCasesByAssistantResponseFromJson(resp)));
}
export async function upsertTestCases(request) {
    await fetchRpc('ai_assistants.v1alpha1.IntegrationTestService/UpsertTestCases', upsertTestCasesRequestToJson(request));
}
export function upsertTestCases$(request, options) {
    return defer(() => upsertTestCasesWithTransport$(getGlobalTransport(), request, options));
}
export function upsertTestCasesWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.IntegrationTestService/UpsertTestCases', upsertTestCasesRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function deleteTestCases(request) {
    await fetchRpc('ai_assistants.v1alpha1.IntegrationTestService/DeleteTestCases', deleteTestCasesRequestToJson(request));
}
export function deleteTestCases$(request, options) {
    return defer(() => deleteTestCasesWithTransport$(getGlobalTransport(), request, options));
}
export function deleteTestCasesWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.IntegrationTestService/DeleteTestCases', deleteTestCasesRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function validateTestCases(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.IntegrationTestService/ValidateTestCases', validateTestCasesRequestToJson(request));
    return validateTestCasesResponseFromJson(raw);
}
export function validateTestCases$(request, options) {
    return defer(() => validateTestCasesWithTransport$(getGlobalTransport(), request, options));
}
export function validateTestCasesWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.IntegrationTestService/ValidateTestCases', validateTestCasesRequestToJson(request), options)
        .pipe(map(resp => validateTestCasesResponseFromJson(resp)));
}
export async function runTestsV2(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.IntegrationTestService/RunTestsV2', runTestsV2RequestToJson(request));
    return runTestsV2ResponseFromJson(raw);
}
export function runTestsV2$(request, options) {
    return defer(() => runTestsV2WithTransport$(getGlobalTransport(), request, options));
}
export function runTestsV2WithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.IntegrationTestService/RunTestsV2', runTestsV2RequestToJson(request), options)
        .pipe(map(resp => runTestsV2ResponseFromJson(resp)));
}
export async function listTestSuites(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.IntegrationTestService/ListTestSuites', listTestSuitesRequestToJson(request));
    return listTestSuitesResponseFromJson(raw);
}
export function listTestSuites$(request, options) {
    return defer(() => listTestSuitesWithTransport$(getGlobalTransport(), request, options));
}
export function listTestSuitesWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.IntegrationTestService/ListTestSuites', listTestSuitesRequestToJson(request), options)
        .pipe(map(resp => listTestSuitesResponseFromJson(resp)));
}
export async function getTestSuite(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.IntegrationTestService/GetTestSuite', getTestSuiteRequestToJson(request));
    return getTestSuiteResponseFromJson(raw);
}
export function getTestSuite$(request, options) {
    return defer(() => getTestSuiteWithTransport$(getGlobalTransport(), request, options));
}
export function getTestSuiteWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.IntegrationTestService/GetTestSuite', getTestSuiteRequestToJson(request), options)
        .pipe(map(resp => getTestSuiteResponseFromJson(resp)));
}
export async function upsertTestSuite(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.IntegrationTestService/UpsertTestSuite', upsertTestSuiteRequestToJson(request));
    return upsertTestSuiteResponseFromJson(raw);
}
export function upsertTestSuite$(request, options) {
    return defer(() => upsertTestSuiteWithTransport$(getGlobalTransport(), request, options));
}
export function upsertTestSuiteWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.IntegrationTestService/UpsertTestSuite', upsertTestSuiteRequestToJson(request), options)
        .pipe(map(resp => upsertTestSuiteResponseFromJson(resp)));
}
export async function deleteTestSuite(request) {
    await fetchRpc('ai_assistants.v1alpha1.IntegrationTestService/DeleteTestSuite', deleteTestSuiteRequestToJson(request));
}
export function deleteTestSuite$(request, options) {
    return defer(() => deleteTestSuiteWithTransport$(getGlobalTransport(), request, options));
}
export function deleteTestSuiteWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.IntegrationTestService/DeleteTestSuite', deleteTestSuiteRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function listTestRuns(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.IntegrationTestService/ListTestRuns', listTestRunsRequestToJson(request));
    return listTestRunsResponseFromJson(raw);
}
export function listTestRuns$(request, options) {
    return defer(() => listTestRunsWithTransport$(getGlobalTransport(), request, options));
}
export function listTestRunsWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.IntegrationTestService/ListTestRuns', listTestRunsRequestToJson(request), options)
        .pipe(map(resp => listTestRunsResponseFromJson(resp)));
}
export async function getTestRunV2(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.IntegrationTestService/GetTestRunV2', getTestRunV2RequestToJson(request));
    return getTestRunV2ResponseFromJson(raw);
}
export function getTestRunV2$(request, options) {
    return defer(() => getTestRunV2WithTransport$(getGlobalTransport(), request, options));
}
export function getTestRunV2WithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.IntegrationTestService/GetTestRunV2', getTestRunV2RequestToJson(request), options)
        .pipe(map(resp => getTestRunV2ResponseFromJson(resp)));
}
export async function cancelTestRunV2(request) {
    await fetchRpc('ai_assistants.v1alpha1.IntegrationTestService/CancelTestRunV2', cancelTestRunV2RequestToJson(request));
}
export function cancelTestRunV2$(request, options) {
    return defer(() => cancelTestRunV2WithTransport$(getGlobalTransport(), request, options));
}
export function cancelTestRunV2WithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.IntegrationTestService/CancelTestRunV2', cancelTestRunV2RequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getTestResult(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.IntegrationTestService/GetTestResult', getTestResultRequestToJson(request));
    return getTestResultResponseFromJson(raw);
}
export function getTestResult$(request, options) {
    return defer(() => getTestResultWithTransport$(getGlobalTransport(), request, options));
}
export function getTestResultWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.IntegrationTestService/GetTestResult', getTestResultRequestToJson(request), options)
        .pipe(map(resp => getTestResultResponseFromJson(resp)));
}
export async function listTestResults(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.IntegrationTestService/ListTestResults', listTestResultsRequestToJson(request));
    return listTestResultsResponseFromJson(raw);
}
export function listTestResults$(request, options) {
    return defer(() => listTestResultsWithTransport$(getGlobalTransport(), request, options));
}
export function listTestResultsWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.IntegrationTestService/ListTestResults', listTestResultsRequestToJson(request), options)
        .pipe(map(resp => listTestResultsResponseFromJson(resp)));
}
export async function retryStuckTestResults(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.IntegrationTestService/RetryStuckTestResults', retryStuckTestResultsRequestToJson(request));
    return retryStuckTestResultsResponseFromJson(raw);
}
export function retryStuckTestResults$(request, options) {
    return defer(() => retryStuckTestResultsWithTransport$(getGlobalTransport(), request, options));
}
export function retryStuckTestResultsWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.IntegrationTestService/RetryStuckTestResults', retryStuckTestResultsRequestToJson(request), options)
        .pipe(map(resp => retryStuckTestResultsResponseFromJson(resp)));
}
export async function generateTestCases(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.IntegrationTestService/GenerateTestCases', generateTestCasesRequestToJson(request));
    return generateTestCasesResponseFromJson(raw);
}
export function generateTestCases$(request, options) {
    return defer(() => generateTestCasesWithTransport$(getGlobalTransport(), request, options));
}
export function generateTestCasesWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.IntegrationTestService/GenerateTestCases', generateTestCasesRequestToJson(request), options)
        .pipe(map(resp => generateTestCasesResponseFromJson(resp)));
}
export async function runSuccessEvaluation(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.IntegrationTestService/RunSuccessEvaluation', runSuccessEvaluationRequestToJson(request));
    return runSuccessEvaluationResponseFromJson(raw);
}
export function runSuccessEvaluation$(request, options) {
    return defer(() => runSuccessEvaluationWithTransport$(getGlobalTransport(), request, options));
}
export function runSuccessEvaluationWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.IntegrationTestService/RunSuccessEvaluation', runSuccessEvaluationRequestToJson(request), options)
        .pipe(map(resp => runSuccessEvaluationResponseFromJson(resp)));
}
export async function cancelSuccessEvaluation(request) {
    await fetchRpc('ai_assistants.v1alpha1.IntegrationTestService/CancelSuccessEvaluation', cancelSuccessEvaluationRequestToJson(request));
}
export function cancelSuccessEvaluation$(request, options) {
    return defer(() => cancelSuccessEvaluationWithTransport$(getGlobalTransport(), request, options));
}
export function cancelSuccessEvaluationWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.IntegrationTestService/CancelSuccessEvaluation', cancelSuccessEvaluationRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function startBulkSuccessEvaluation(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.IntegrationTestService/StartBulkSuccessEvaluation', startBulkSuccessEvaluationRequestToJson(request));
    return startBulkSuccessEvaluationResponseFromJson(raw);
}
export function startBulkSuccessEvaluation$(request, options) {
    return defer(() => startBulkSuccessEvaluationWithTransport$(getGlobalTransport(), request, options));
}
export function startBulkSuccessEvaluationWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.IntegrationTestService/StartBulkSuccessEvaluation', startBulkSuccessEvaluationRequestToJson(request), options)
        .pipe(map(resp => startBulkSuccessEvaluationResponseFromJson(resp)));
}
export async function getSuccessEvaluatorStat(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.IntegrationTestService/GetSuccessEvaluatorStat', getSuccessEvaluatorStatRequestToJson(request));
    return getSuccessEvaluatorStatResponseFromJson(raw);
}
export function getSuccessEvaluatorStat$(request, options) {
    return defer(() => getSuccessEvaluatorStatWithTransport$(getGlobalTransport(), request, options));
}
export function getSuccessEvaluatorStatWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.IntegrationTestService/GetSuccessEvaluatorStat', getSuccessEvaluatorStatRequestToJson(request), options)
        .pipe(map(resp => getSuccessEvaluatorStatResponseFromJson(resp)));
}
export async function listSuccessEvaluatorStatsForAssistant(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.IntegrationTestService/ListSuccessEvaluatorStatsForAssistant', listSuccessEvaluatorStatsForAssistantRequestToJson(request));
    return listSuccessEvaluatorStatsForAssistantResponseFromJson(raw);
}
export function listSuccessEvaluatorStatsForAssistant$(request, options) {
    return defer(() => listSuccessEvaluatorStatsForAssistantWithTransport$(getGlobalTransport(), request, options));
}
export function listSuccessEvaluatorStatsForAssistantWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.IntegrationTestService/ListSuccessEvaluatorStatsForAssistant', listSuccessEvaluatorStatsForAssistantRequestToJson(request), options)
        .pipe(map(resp => listSuccessEvaluatorStatsForAssistantResponseFromJson(resp)));
}
export async function listSuccessEvaluatorResults(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.IntegrationTestService/ListSuccessEvaluatorResults', listSuccessEvaluatorResultsRequestToJson(request));
    return listSuccessEvaluatorResultsResponseFromJson(raw);
}
export function listSuccessEvaluatorResults$(request, options) {
    return defer(() => listSuccessEvaluatorResultsWithTransport$(getGlobalTransport(), request, options));
}
export function listSuccessEvaluatorResultsWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.IntegrationTestService/ListSuccessEvaluatorResults', listSuccessEvaluatorResultsRequestToJson(request), options)
        .pipe(map(resp => listSuccessEvaluatorResultsResponseFromJson(resp)));
}
